namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmDenikSslSpisovyUzel extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmDenikSslSpisovyUzelReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmDenikSslSpisovyUzelObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailAdmDenikSslSpisovyUzelObj());
            this.detailObj.createBase({
                contentName: "detailAdmDenikSslSpisovyUzel",
                contentCaption: "jres:33000615", //RC 33000615 : Navázaný spisový uzel na podací deník
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailAdmDenikSslSpisovyUzel", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailAdmDenikSslSpisovyUzelObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmDenikSslSpisovyUzelReadDto> {
        openSpisovyUzel: boolean;

        create() {

        }

        textPopis(): string | undefined | null {
            return `${this.data.sslden} - ${this.data.ixs_su_txt}`;
        }

        setSxsDetail(): string {
            return `${this.data.ixs_su}#${this.data.sslden}#${this.data.subrada}#`
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmDenikSslSpisovyUzelSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            data.subrada = 1;
            this.cnt.isl.AdmDenikSslSpisovyUzel.upsert({ data: data }).get().then((output: any) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            filterObj.openSpisovyUzel = this.openSpisovyUzel;
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailAdmDenikSslSpisovyUzel", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.AdmDenikSslSpisovyUzel.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return `${this.options.contentCaption} - ${this.textPopis()}`
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null;
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            if (this.openSpisovyUzel == true) {
                this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), {
                    model: "model.ixs_su=value.ixs_su",
                    dropdown: false,
                    flag: this.createFlagNemenne(),
                });
                this.MakeSelectField("sslden", Gordic.Prefabs.Select.sslsden(), {
                    model: "model.sslden=value.sslden",
                    itemTemplate: "{sslden}",
                    flag: this.createFlagNemenne(),
                    serverFilters: {
                        PouzeUzivatelskeDeniky: false,
                        aktivita: this.getAllAktivita()
                    }
                })
            } else {
                this.MakeSelectField("sslden", Gordic.Prefabs.Select.sslsden(), {
                    model: "model.sslden=value.sslden",
                    itemTemplate: "{sslden}",
                    flag: this.createFlagNemenne(),
                    serverFilters: {
                        PouzeUzivatelskeDeniky: false,
                        aktivita: this.getAllAktivita()
                    }
                })
                this.MakeSelectField("ixs_su", Gordic.Prefabs.Select.ginspod(), {
                    model: "model.ixs_su=value.ixs_su",
                    dropdown: false,
                    flag: this.createFlagNemenne()
                });
            }
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" })
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" })
            this.MakeField("dat_zmena");
        }
    }
}